"use client"

import { t } from "@/languages/i18n"
import { CalendarOutlined, EyeOutlined, KeyOutlined } from "@ant-design/icons"
import { Select, Typography } from "antd"
import dayjs from "dayjs"

const { Text } = Typography

interface StatusPublishProps {
  status: string
  setStatus: (status: string) => void
}

export const StatusPublish = ({ status, setStatus }: StatusPublishProps) => {
  return (
    <div>
      <Text className="text-sm">
        <KeyOutlined /> {t("Trạng thái")}:
        <Select
          className="w-fit ml-2"
          onChange={(value) => setStatus(value)}
          options={[
            { value: "Draft", label: t("Bản nháp") },
            { value: "Published", label: t("Xuất bản") },
          ]}
          value={status}
        />
      </Text>
    </div>
  )
}

export const VisibilityPublish = ({ status }: { status: string }) => {
  const isPublished = status === "Published"
  return (
    <div>
      <Text className="text-sm">
        <EyeOutlined /> {t("Hiển thị")}:
        <span className="ml-2">{isPublished ? t("Công khai") : t("Bản nháp")}</span>
      </Text>
    </div>
  )
}

export const DatePublish = () => {
  const now = dayjs()
  return (
    <div>
      <Text className="text-sm">
        <CalendarOutlined /> {t("Ngày tạo")}:
        <span className="ml-2 text-xs">
          {now.format("DD/MM/YYYY HH:mm")}
        </span>
      </Text>
    </div>
  )
}